export default [
  {
    name: 'superSendAuthLink',
    path: '/superSendWeChat',
    component: () =>
      import(
        /* webpackChunkName: "superSendWeChant" */ '@/pages/superSendWeChat/index.vue'
      ),
    meta: {
      title: '授权链接',
    },
  },
  {
    name: 'selectProductAddZbRoom',
    path: '/selectProduct',
    component: () =>
      import(
        /* webpackChunkName: "selectProduct" */ '@/pages/selectProduct/index.vue'
      ),
    meta: {
      title: '邀请链接',
    },
  },
]
